import { useNavigate } from 'react-router';
import * as S from './styles';
import { Icon } from '@iconify/react';
import { Button } from '../Button';

export function GoBack(){
  const navigate = useNavigate();

  function handleGoBack() {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  }

  return (
    <S.Container onClick={handleGoBack}>
      <Button type='button' variant='tertiary' size='sm'>
        <Icon icon='ic:outline-arrow-back' height='20px' />
      </Button>
    </S.Container>
  )
}
